export default __webpack_public_path__ + "static/media/case-XC90.96a9cc66.jpg";